import React, { useEffect }  from 'react';

const PosicionForm = ({posicion, posicionInput, setPosicion}) => {
	useEffect(() => {
		if (posicion) {
			const input = document.getElementById('posicion_title');
			if (input) {
				input.value = posicion.posicion
			}
		}
	}, [posicion]);

	return (
		<div className="full row align-center">
			<div className="column full">
				<div className="input-form-content row full align-center">
					<div className="column label-normal">
						<p><b>Posición:</b></p>
					</div>
					<div className="column full">
						<input
							id				=	"posicion_title"
							className		=	"input input-modals"  
							type			=	"text" 
							name			=	"posicion_title" 
							autoComplete 	=	'off'
							value			=	{posicionInput}
							onChange		=	{(e) => setPosicion(e.target.value)}
							required
						/>
					</div>
				</div>
			</div>
		</div>
	)
}

export default PosicionForm;
